import { Validation } from "@shared/lib/utils";

const profileFormValid = (formData) => {
  let errorsState = {};

  const validationFirstName = new Validation({
    field: formData.firstName,
    title: "First name",
  })
    .isRequired()
    .maxLenght(30)
    .getErrors();

  const validationLastName = new Validation({
    field: formData.lastName,
    title: "Last name",
  })
    .maxLenght(30)
    .getErrors();

  const validationEmail = new Validation({
    field: formData.email,
    title: "Email",
  })
    .isRequired()
    .isEmail()
    .maxLenght(64)
    .getErrors();

  if (validationFirstName.length) {
    errorsState = {
      ...errorsState,
      firstName: validationFirstName[0],
    };
  }

  if (validationLastName.length) {
    errorsState = {
      ...errorsState,
      lastName: validationLastName[0],
    };
  }

  if (validationEmail.length) {
    errorsState = {
      ...errorsState,
      email: validationEmail[0],
    };
  }

  return errorsState;
};

export default profileFormValid;
